import { render } from "./FakeInput.vue?vue&type=template&id=ed614e2a&lang=pug"
import script from "./FakeInput.vue?vue&type=script&lang=js"
export * from "./FakeInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__